import React from "react";
import Typical from "react-typical";

const Home = () => {
  return (
    <div className="flex justify-center items-center mt-[50vh]">
      <h1 className="mb-1 font-mono text-4xl text-gray-100 md:text-6xl">
        Hi, I am a{" "}
        <Typical
          steps={[
            "Software Engineer 👋",
            1000,
            "Full Stack Developer 💻",
            1000,
            "Problem Solver !!",
            1000,
          ]}
          loop={Infinity}
          wrapper="b"
        />
      </h1>
    </div>
  );
};

export default Home;
